// ─────────────────────────────────────────────────────────────────────────────
// readers.ts
//
// Cassette type (housing) catalog for the scanner demo.
//
// Add entries to DEFAULT_HOUSINGS to test additional cassette types.
// Drop the unified JSON file into /public/models/<name>/ and add a matching
// entry here — the dropdown in PreScanPage picks it up automatically.
// ─────────────────────────────────────────────────────────────────────────────

/** A single cassette type — drives the WASM model loaded by the engine. */
export interface HousingConfig {
  /** Unique identifier — used as React list key and for equality checks. */
  id: string;
  /** Human-readable name shown in the cassette-type dropdown. */
  label: string;
  /** URL of the unified JSON file (testConfig + pointModel + classifier). */
  config: string;
  /** Optional URL to a cassette photo shown in the dropdown. */
  imageUrl?: string;
}

/**
 * Available cassette types.
 * To add one: drop the unified JSON file into /public/models/<name>/
 * and add an entry here.
 */
export const DEFAULT_HOUSINGS: HousingConfig[] = [
  {
    id: 'reagena',
    label: 'Reagena - 1 Strip',
    config: '/models/reagena/reagena.unified.json',
  },
  {
    id: 'phoenix',
    label: 'Phoenix - 1 Strip',
    config: '/models/phoenix/phoenix.unified.json',
  },
  {
    id: 'abcdx',
    label: 'ABCDx - 2 Strip',
    config: '/models/abcdx/abcdx.unified.json',
  },
  {
    id: 'premier_bio',
    label: 'Premier - 10 Strip',
    config: '/models/premier_bio/premier_bio.unified.json',
  },
  {
    id: 'premier_bio_paths',
    label: 'Premier - 10 Strip (SVG overlay)',
    config: '/models/premier_bio/premier_bio_paths.unified.json',
  },
  {
    id: 'premier_bio_broken',
    label: 'Premier - 10 Strip (SVG, broken - no pathData)',
    config: '/models/premier_bio/premier_bio_broken.unified.json',
  },
  {
    id: 'brugia',
    label: 'Brugia - 1 Strip',
    config: '/models/brugia/brugia.unified.json',
  },
  {
    id: 'oncho',
    label: 'Oncho - 1 Strip',
    config: '/models/oncho/oncho.unified.json',
  },
  {
    id: 'buhlmann',
    label: 'Buhlmann - CALE',
    config: '/models/buhlmann/unified_buhlmann_DEMO.json',
  },
];
